import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

interface IAccessoryLabelProps {
  compact?: boolean
}

const ACCESSORY_LABEL_STYLES =
  'flex my-auto mr-3 mb-0 md: xl:flex text-xs truncate p-0 m-0'

export const AccessoryLabel: React.FC<PropsWithChildren<
  IAccessoryLabelProps
>> = ({ compact, children }) => (
  <span
    className={concatStyles([ACCESSORY_LABEL_STYLES, compact ? 'hidden' : ''])}
  >
    {children}
  </span>
)
